const classes = Object.freeze({
    root: 'll-card ll-standard-card options',
});

export {
    classes,
};